import { useSearchParams } from 'react-router-dom';

export const useSearchParamsHelper = () => {
  const [searchParams] = useSearchParams();
  const searchParamsObj = Object.fromEntries(searchParams.entries());

  const addParams = (newParams) =>
    new URLSearchParams({
      ...searchParamsObj,
      ...newParams,
    });

  const removeParam = (param) => {
    const { [param]: p, ...rest } = searchParamsObj;
    return new URLSearchParams(rest);
  };

  return {
    addParams,
    removeParam,
  };
};
